import { types, applySnapshot } from 'mobx-state-tree';
import Framework from '@greenville/framework';
import * as constants from '../../../common/constants';

const bookTitleData = types.model('bookTitleData', {
  id: types.maybeNull(types.string),
  title: types.maybeNull(types.string),
  bookId: types.maybeNull(types.string),
  channelsId: types.maybeNull(types.string),
  version: types.maybeNull(types.union(types.string, types.number))
});

const GetBookTitlesDataModel = types
  .model('GetBookTitlesDataModel', {
    data: types.optional(types.array(bookTitleData), [])
  })
  .actions((self) => ({
    fetch(payload) {
      Framework.getEventManager().publish(constants.FETCH_BOOK_TITLES_DATA, {
        payload
      });
    },
    setResponse(response) {
      applySnapshot(self, response.data);
      Framework.getEventManager().publish(constants.SET_BOOK_TITLES_DATA);
    },
    resetStoreValues() {
      const initialState = [];
      applySnapshot(self.data, initialState);
      Framework.getEventManager().publish(constants.SET_BOOK_TITLES_DATA);
    }
  }));

export default GetBookTitlesDataModel;
